<mat-card
  [ngClass]="{ 'note--edit': editMode() }"
  class="note-card"
  [ngStyle]="{ 'border-color': noteService.colors[currentNote.status] }">
  <form (ngSubmit)="saveNote(currentNote)" (click)="navigateToDU()">
    <div [class]="'note__content '">
      <div class="note__infos">
        <mat-icon color="primary" matPrefix [svgIcon]="'note-' + currentNote.status"></mat-icon>
        <mat-select
          focused="false"
          [disabled]="!editMode()"
          name="status"
          [(ngModel)]="currentNote.status"
          (selectionChange)="onStatusChange()"
          [class.disabled]="!editMode()"
          [panelWidth]="''">
          <!-- If the user can't edit the note we should display only the note status -->
          @if (!availableStatus.includes(currentNote.status)) {
            <mat-option class="note--option" [value]="currentNote.status">
              <mat-icon color="primary" [svgIcon]="'note-' + currentNote.status"></mat-icon>
              {{ currentNote.status }}
            </mat-option>
          }
          @for (stat of availableStatus; track $index) {
            <mat-option class="note--options" [value]="stat">
              <mat-icon color="primary" [svgIcon]="'note-' + stat"></mat-icon>
              {{ stat }}
            </mat-option>
          }
        </mat-select>
        @if (hasWarning()) {
          <div class="note-warning">
            <mat-icon class="inline-note-warning-sign" svgIcon="warning" />
            <span class="inline-note-warning-text">{{ "notes.inline.warning.modified" | translate }}</span>
          </div>
        }
      </div>
      @if (titleService.headerTitle === "notes.label") {
        <p class="note--dmc">
          {{ currentNote.shortDMC }}
        </p>
      }
      @if (editMode()) {
        @if (store.pubInfo?.capabilities?.notesInline && currentNote.status === "corporate") {
          @let selectedAnchor = noteService.selectedAnchor ?? "notes.anchor.none" | translate;
          @let anchorId = currentNote.anchor?.id ?? "notes.anchor.none" | translate;
          <div class="note-anchor-container">
            <div>{{ "notes.anchor.label" | translate }} {{ anchorId }}</div>
            @if (selectedAnchor !== anchorId) {
              <div>{{ "notes.anchor.change" | translate }} {{ selectedAnchor }}</div>
            }
          </div>
        }
        <mat-form-field id="title_note" [subscriptSizing]="'dynamic'">
          <!-- The title can't exceed 200 characters. The 'pattern' attribute force the title to not be empty
         or composed only of spaces. -->
          <input
            title="note-title"
            class="note__title note__title--edit"
            matInput
            [(ngModel)]="currentNote.customTitle"
            #titleInput
            name="customTitle"
            (change)="onchange()"
            required
            pattern=".*\S+.*"
            maxlength="200" />
          <mat-error>
            {{ "error.title.required" | translate }}
          </mat-error>
          <mat-label>{{ "notes.title" | translate }}</mat-label>
        </mat-form-field>
        <mat-form-field id="content_note" [subscriptSizing]="'dynamic'">
          <textarea
            matInput
            title="note-content"
            class="note__content--edit"
            [(ngModel)]="currentNote.content"
            name="content"
            cdkTextareaAutosize
            (change)="onchange()"></textarea>
          <mat-label>{{ "notes.content" | translate }}</mat-label>
        </mat-form-field>
        @if (noteService.canAttachMedia) {
          <button
            mat-raised-button
            class="add-media-button"
            type="button"
            [disabled]="
              currentNote.status === 'private' && store.mediaStorageUsed + newMediaSize >= noteService.mediaStorageLimit
            "
            (click)="fileInput.click()">
            <mat-icon svgIcon="attach-file"></mat-icon>
            {{ "notes.media.add" | translate }}
          </button>
          <input [accept]="ALLOWED_MIME_TYPES_LIST" type="file" hidden #fileInput (change)="addMedia($event)" />
          <ng-container *ngTemplateOutlet="mediaPanel"></ng-container>
        }
      } @else {
        @if (store.pubInfo?.capabilities?.notesInline && currentNote.anchor?.id) {
          <div class="note__anchor">{{ "notes.anchor.label" | translate }} {{ currentNote.anchor.id }}</div>
        }
        <div class="note__title">{{ currentNote.customTitle }}</div>
        <div class="note__area">{{ currentNote.content }}</div>
      }
    </div>
    @if (editMode()) {
      <div class="note--submit">
        <button class="note--cancel" mat-raised-button type="button" (click)="cancel($event)">
          {{ "tocItem.cancel" | translate }}
        </button>
        <button
          class="note--save"
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!currentNote.customTitle || currentNote.customTitle.trim().length === 0">
          {{ "tocItem.save" | translate }}
        </button>
      </div>
    }

    @if (noteService.canAttachMedia && !editMode()) {
      <ng-container *ngTemplateOutlet="mediaPanel" />
    }

    <div class="note-footer">
      <div class="note_infos">
        <span>{{
          "tocItem.createdBy"
            | translate
              : {
                  author: currentNote.author ?? "Unknown user",
                  date: currentNote.date | date: "medium" : "" : store.currentLanguage,
                  rev: currentNote.minRevision | parseRevision
                }
        }}</span>
      </div>
      @if (noteService.canAttachMedia && !editMode() && currentNote.medias?.length) {
        <div class="medias-panel-label" (click)="toggleMediaPanel($event)">
          {{ (showMediaPanel ? "notes.medias.hide" : "notes.medias.show") | translate }} ({{
            totalMediaSize | byteFormat
          }})
        </div>
      }
    </div>
  </form>

  @if (!editMode() && canOpenMenu && !this.noteService.editingNote()) {
    <div class="note--actions-export">
      <button
        type="button"
        title="note-menu-export"
        mat-icon-button
        class="note--export-menu-button"
        [mat-menu-trigger-for]="exportMenu">
        <mat-icon color="primary" svgIcon="menu-kebab"></mat-icon>
      </button>
    </div>
  }

  @if (currentNote.technicalEvent?.reference) {
    <div class="note--te" (click)="openURL()">
      {{ currentNote.technicalEvent.reference }}
    </div>
  }
</mat-card>

<mat-menu #exportMenu="matMenu" class="note__export-menu">
  <button mat-menu-item class="note__startEdit" (click)="startEdit()">
    <mat-icon color="primary" svgIcon="pencil"></mat-icon>
    {{ "notes.edit" | translate }}
  </button>
  <button mat-menu-item class="note__delete" (click)="delete()">
    <mat-icon color="primary" svgIcon="delete"></mat-icon>
    {{ "notes.delete" | translate }}
  </button>
  @if (!currentNote.technicalEvent?.id && webtek()) {
    <button mat-menu-item class="note__WebTek-dialog" type="button" (click)="exportToWebTek()">
      <mat-icon color="primary" svgIcon="open-in-new" />
      {{ "webTek.export" | translate }}
    </button>
  } @else if (webtek()) {
    <button mat-menu-item class="note__WebTek-go" type="button" (click)="openURL()">
      <mat-icon color="primary" svgIcon="open-in-new" />
      {{ "webTek.go" | translate }}
    </button>
  } @else if (store.isGov) {
    <button
      mat-menu-item
      class="note__transform"
      type="button"
      [disabled]="!canTransformIntoComment"
      (click)="transformIntoComment()">
      <mat-icon color="primary" svgIcon="open-in-new" />
      {{ "notes.transformIntoComment" | translate }}
    </button>
  }
  @if (hasWarning()) {
    <button mat-menu-item type="button" (click)="confirmPosition()">
      <mat-icon color="primary" svgIcon="check" />
      {{ "notes.anchor.confirm" | translate }}
    </button>
  }
</mat-menu>

<ng-template #mediaPanel>
  @if (currentNote.medias?.length) {
    <div class="info" [class.hide-panel]="!editMode() && !showMediaPanel">
      <div class="key">{{ "front.attached-medias" | translate }}</div>
      <ul class="medias-panel value">
        @for (media of currentNote.medias; track $index) {
          <li>
            <div class="media-list-item">
              <div>
                <span class="media-link" (click)="openMedia($event, media.id, media.title)"> {{ media.title }} </span>
                @if (editMode()) {
                  <span>({{ media.size | byteFormat }})</span>
                }
              </div>
              @if (editMode()) {
                <button type="button" title="Remove media" mat-icon-button matIconSuffix (click)="removeMedia(media)">
                  <mat-icon svgIcon="delete"></mat-icon>
                </button>
              }
            </div>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>
